module.exports = __webpack_public_path__ + "img/3.088e1176.svg";